import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function InformationFilledIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m0 10a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1m0-4.25A1.125 1.125 0 1 0 12 9a1.125 1.125 0 0 0 0-2.25"
        clipRule="evenodd"
      />
    </Icon>
  );
}

InformationFilledIcon.displayName = 'InformationFilledIcon';
